export const mockVolunteerOpportunities = [
  {
    id: "1",
    title: "هماهنگ‌کننده برنامه آموزشی",
    commitment: "هفتگی",
    location: "دورکاری",
    category: "Education",
    description: "در هماهنگی ابتکار آموزش دختران ما کمک کنید — ارتباطات با مکاتب همکار را مدیریت کنید، پیشرفت دانش‌آموزان را پیگیری کنید و گزارش‌ها را تهیه کنید.",
    skills: ["ارتباطات", "سازماندهی", "MS Office"],
    spots: 3,
  },
  {
    id: "2",
    title: "مترجم پشتو / دری",
    commitment: "انعطاف‌پذیر",
    location: "دورکاری",
    category: "Language",
    description: "اسناد، محتوای وب‌سایت و ارتباطات را بین انگلیسی و پشتو یا دری برای حمایت از عملیات دوزبانه ما ترجمه کنید.",
    skills: ["پشتو یا دری", "انگلیسی", "توجه به جزئیات"],
    spots: 5,
  },
  {
    id: "3",
    title: "داوطلب جمع‌آوری کمک و رویدادها",
    commitment: "ماهانه",
    location: "تورنتو / اوتاوا",
    category: "Fundraising",
    description: "در برنامه‌ریزی و اجرای رویدادهای جمع‌آوری کمک، کمپین‌های ارتباط با اهداکنندگان و فعالیت‌های آگاهی‌بخشی جامعه در سراسر کانادا کمک کنید.",
    skills: ["برنامه‌ریزی رویداد", "رسانه‌های اجتماعی", "شبکه‌سازی"],
    spots: 8,
  },
  {
    id: "4",
    title: "تولیدکننده محتوای رسانه‌های اجتماعی",
    commitment: "هفتگی",
    location: "دورکاری",
    category: "Marketing",
    description: "محتوای جذاب برای کانال‌های رسانه‌های اجتماعی ما ایجاد کنید، پست‌های وبلاگ بنویسید و به رشد حضور آنلاین ما کمک کنید.",
    skills: ["رسانه‌های اجتماعی", "نویسندگی", "طراحی گرافیک"],
    spots: 2,
  },
  {
    id: "5",
    title: "متخصص پزشکی (میدانی)",
    commitment: "فصلی",
    location: "افغانستان (میدانی)",
    category: "Healthcare",
    description: "به عنوان پزشک، پرستار یا پیراپزشک به تیم‌های کلینیک سیار ما بپیوندید. مراقبت‌های اولیه صحی را به جوامع محروم در مناطق روستایی افغانستان ارائه دهید.",
    skills: ["جواز طبی", "کمک‌های اولیه", "ارتباطات بین‌فرهنگی"],
    spots: 4,
  },
  {
    id: "6",
    title: "متخصص نوشتن گرانت",
    commitment: "انعطاف‌پذیر",
    location: "دورکاری",
    category: "Administration",
    description: "فرصت‌های تأمین مالی را تحقیق کنید و پیشنهادهای گرانت قانع‌کننده برای تأمین حمایت مالی از بنیادهای کانادایی و بین‌المللی بنویسید.",
    skills: ["نوشتن گرانت", "تحقیق", "نویسندگی انگلیسی"],
    spots: 2,
  },
];

export const mockTestimonials = [
  {
    id: "1",
    name: "سارا میچل",
    role: "داوطلب هماهنگ‌کننده آموزش",
    duration: "۲ سال",
    quote: "داوطلبی با CAF یکی از پرمعناترین تجربیات زندگی من بوده است. دیدن تأثیر مستقیم بر آموزش دختران فوق‌العاده ارزشمند است.",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20Canadian%20woman%20smiling%2C%20headshot%20portrait%2C%20warm%20natural%20lighting%2C%20clean%20background&width=100&height=100&seq=vol1&orientation=squarish",
  },
  {
    id: "2",
    name: "احمد کریمی",
    role: "مترجم پشتو",
    duration: "۳ سال",
    quote: "به عنوان یک افغان-کانادایی، مشارکت در مأموریت CAF مانند بازگشت به ریشه‌هایم احساس می‌شود. تیم پرشور است و کار واقعاً مهم است.",
    avatar: "https://readdy.ai/api/search-image?query=Afghan%20Canadian%20man%20smiling%2C%20professional%20headshot%2C%20warm%20lighting%2C%20clean%20background&width=100&height=100&seq=vol2&orientation=squarish",
  },
  {
    id: "3",
    name: "داکتر پریا شارما",
    role: "داوطلب میدانی طبی",
    duration: "۱ سال",
    quote: "برنامه کلینیک سیار صحی زندگی‌ها را تغییر می‌دهد. من بیمارانی را درمان کردم که قبلاً هرگز داکتر ندیده بودند. CAF غیرممکن را ممکن می‌سازد.",
    avatar: "https://readdy.ai/api/search-image?query=South%20Asian%20female%20doctor%20smiling%2C%20professional%20portrait%2C%20warm%20lighting%2C%20clean%20background&width=100&height=100&seq=vol3&orientation=squarish",
  },
];